import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/admin.css'
import App from './App.tsx'
import { consumeSsoHandoff } from './lib/consumeSsoHandoff'
import { loadImageMap } from './hooks/useSiteImage'

const rootEl = document.getElementById('root')!

// Same head-start as the './i18n' import above: on a first-ever visit
// (nothing in localStorage yet for useSiteImage's own cache), this gives
// the site-images fetch a chance to resolve before any component using
// useSiteImage has even mounted, instead of only starting once one does.
void loadImageMap()

// Apply an incoming cross-app SSO session (if any) before first render, so
// an admin arriving from the Operations Hub lands straight in /admin without
// a login prompt. No-ops instantly for regular storefront visitors.
consumeSsoHandoff().finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
